module.exports = __webpack_public_path__ + "static/media/icon-check.461ed493.gif";